import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';

async function createResetPasswordUrl(): Promise<{ ticket: string }> {
    const { data } = await api.post(`/users/reset-password`);
    return data;
}

export function useCreateResetPasswordUrl(): UseMutationResult<{ ticket: string }, AxiosError, string, unknown> {
    return useMutation(createResetPasswordUrl);
}
